import React from "react";
import { Form } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { useDispatch, useSelector } from "react-redux";
import {
  clientSelector,
  createClient,
  resetClient,
  setClientField,
  updateClient,
} from "../../../redux/clientSlice";
import { error } from "../../../redux/notificationSlice";
import { pageSizeSelector } from "../../../redux/surveySlice";
import { api } from "../../../services/api-service";
import ClientFields from "../../Form/ClientFields";

const AddNewClient = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const client = useSelector(clientSelector).client;
  const fields = [
    {
      title: "Full Name",
      name: "name",
      required: true,
      type: "text",
      value: client["name"],
      onChange: (value) => handleChange("name", value),
    },
    {
      title: "Reference Number",
      name: "clientRef",
      type: "number",
      required: true,
      disabled: client.id ? true : false,
      value: client["clientRef"],
      onChange: (value) => handleChange("clientRef", value),
    },
    {
      title: "Authority Letter",
      name: "authorityLetter",
      type: "file",
      required: false,
      value: client["authorityLetter"],
      onChange: (value) => handleAuthorityLetter("authorityLetter", value),
    },
    {
      title: "Email",
      name: "email",
      type: "email",
      required: false,
      value: client["email"],
      onChange: (value) => handleChange("email", value),
    },
    {
      title: "Address",
      name: "address",
      required: false,
      value: client["address"],
      type: "textarea",
      onChange: (value) => handleChange("address", value),
    },
  ];

  const handleAuthorityLetter = async (type, e) => {
    if (e.target.files.length > 0) {
      const formdata = new FormData();
      formdata.append("file", e.target.files[0]);
      const response = await api.post("upload", formdata);
      if (response.ok) {
        dispatch(setClientField({ field: type, value: response.data.data }));
      }
    }
  };

  const handleChange = (field, e) => {
    dispatch(setClientField({ field, value: e.target.value }));
  };

  const addNewClient = async (e) => {
    e.preventDefault();
    if (client.clientRef.length !== 4) {
      dispatch(error("Client Reference must be of 4 digits"));
      return;
    }
    if (client.id) {
      dispatch(updateClient(client));
      return;
    }
    dispatch(createClient(client));
  };

  const closeModal = () => {
    dispatch(resetClient());
    onHide();
  };

  return (
    <Modal show={show} onHide={() => onHide()} className="modalPopup" centered>
      <Modal.Header>
        <div className="media-body">
          <h2>{!client.id ? "Add New Client" : "Update Client"}</h2>
          {!client.id ? (
            <p>Fill the form below to add new client</p>
          ) : (
            <p>Update the form below for the client</p>
          )}
        </div>
        <button className="cta-text" onClick={() => closeModal()}>
          Cancel
        </button>
      </Modal.Header>
      <form onSubmit={(e) => addNewClient(e)}>
        <Modal.Body className="show-grid">
          <Row>
            {fields.map((field, index) => (
              <ClientFields
                field={field}
                index={index}
                key={index}
                id={client.id}
              />
            ))}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="cta-form justify-content-between w-100">
            {!client.id && (
              <button
                type="reset"
                onClick={() => dispatch(resetClient())}
                className="cta-text"
              >
                Reset
              </button>
            )}
            <button className="btn cta-primary ml-auto">
              {client.id ? "Update" : "Add"}
            </button>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default AddNewClient;
